import { genComponentEl } from '@/utils/utils';
import Component from './component.vue';

/**
 *更新HT300设备信息
 *
 * @param {Object} data
 */
export function updateHt300DeviceInfoDialog(data) {
  genComponentEl(Component, data);
}
